import * as yup from 'yup';

export const userMatriculadoEditSchema = yup.object().shape({
  nombre: yup.string().required('El nombre es requerido.'),
  apellido: yup.string().required('El apellido es requerido.'),
  email: yup
    .string()
    .email('El email no es válido.')
    .required('El email es requerido.'),
  dni: yup
    .number()
    .max(99999999, 'El DNI no puede tener más de 8 dígitos.')
    .min(1000000, 'El DNI no puede tener menos de 7 dígitos.')
    .typeError('Ingrese solo números.')
    .required('El número de documento es requerido.'),
  matricula: yup
    .number()
    .typeError('Ingrese solo números.')
    .required('El número de matrícula es requerido.')
});
